import { cn } from '@/lib/utils'
import { forwardRef, type ComponentProps, type MouseEvent } from 'react'

export type LinkCardActionProps = Omit<ComponentProps<'span'>, 'ref'> & {
  disabled?: boolean
}

const LinkCardAction = forwardRef<HTMLSpanElement, LinkCardActionProps>(
  ({ children, className, onClick, disabled = false, ...props }, ref) => {
    const handleClick = (e: MouseEvent<HTMLSpanElement>) => {
      if (disabled) return

      e.preventDefault()
      e.stopPropagation()
      onClick?.(e)
    }

    return (
      <span
        ref={ref}
        className={cn('cursor-pointer', disabled && 'opacity-50 cursor-not-allowed', className)}
        onClick={handleClick}
        {...props}
      >
        {children}
      </span>
    )
  }
)

export default LinkCardAction
